/*global googleFonts*/

import { Controller } from "@hotwired/stimulus";
import Customization from "./customization";
import customizationDecoder from "jwt-decode";
import { misc, CustomizationLoader } from "./customization/category";
import Draggable from "./customization/draggable";
import { v4 as uuidv4 } from "uuid";
import { buildForm, loadFonts, makeRequest } from "./customization/lib";

// Connects to data-controller="site-builder--wizard"
export default class extends Controller {
  static values = {
    wizardWidth: Number,
  };

  initialize() {
    this.isPersisted = !!document.body.dataset.siteBuilderSite;
    this.wizardElement = this.element;
    this.wizardWidthValue = this.wizardElement.offsetWidth;
    new Draggable(
      document.querySelector(".wizard-options"),
      this.wizardElement
    );

    this.#renderFromEncodedQueryParam();
    this.#renderFromQueryParam();
    this.#setRequestedPage();
    if (this.isPersisted) {
      Customization.reset({ skip_url: true });
    } else {
      this.#generateUniqueUserId();
    }

    loadFonts(this.isPersisted ? googleFonts : null);
  }

  closeAllPanel() {
    this.hideAllPanels();
    this.removeAllMenuSelection();
  }

  removeAllMenuSelection() {
    const elements = document.querySelectorAll(".wizard-options .tab-item");

    elements.forEach((element) => {
      element.classList.remove("selected");
    });
  }

  hideAllPanels() {
    const menus = document.querySelector(".wizard-actions").children;
    for (const menu of menus) {
      menu.style.display = "none";
    }
    this.wizardWidthValue = this.wizardElement.offsetWidth;
    return menus;
  }

  change(e) {
    const id = e.currentTarget.id.replace("for-", "");
    this.render(`customizable-${id}`);
    this.removeAllMenuSelection();
    e.currentTarget.classList.add("selected");
    this.wizardWidthValue = this.wizardElement.offsetWidth;
  }

  discard() {
    if (
      window.confirm(
        "You will discard the saved customization, are you sure you want to reset?"
      )
    ) {
      Customization.reset();
      location.reload();
    }
  }

  render(current) {
    const menus = this.hideAllPanels();
    for (const menu of menus) {
      if (menu.classList.contains(current)) {
        menu.style.display = "grid";
      }
    }
    this.wizardWidthValue = this.wizardElement.offsetWidth;
  }

  wizardWidthValueChanged(value, previousValue) {
    if (this.wizardElement.classList.contains("right")) {
      if (value < previousValue) {
        const left = this.wizardElement.offsetLeft + previousValue - value;
        this.wizardElement.style.left = `${left}px`;
      } else {
        const left =
          this.wizardElement.offsetLeft -
          document.querySelector(".wizard-actions").offsetWidth;
        this.wizardElement.style.left = `${left}px`;
      }
    }
  }

  async onContactClicked() {
    const formData = buildForm("Contact Us");
    await makeRequest(formData);
    return true;
  }

  #renderFromQueryParam() {
    const customization = this.#queryParamValue("email");
    if (!customization) return;

    const runner = new CustomizationLoader({});
    runner.run({ email: customization });
    this.#queryFreeUrlRedirect();
  }

  #setRequestedPage() {
    const url = this.#queryParamValue("url");
    if (!url) return;

    const runner = new CustomizationLoader();
    runner.run({ url });
    this.#queryFreeUrlRedirect();
  }

  #renderFromEncodedQueryParam() {
    const encodedCustomizations = this.#queryParamValue("q");
    if (!encodedCustomizations) return;

    const customizations = this.#decodeCustomizations(encodedCustomizations);
    if (
      window.confirm(
        "You are preloading customizations, this will reset existing customization (if any). Are you sure you want to continue?"
      )
    ) {
      const runner = new CustomizationLoader();
      runner.run(customizations);
    }

    /*
        Hide query params in any case
     */
    this.#queryFreeUrlRedirect();
  }

  #decodeCustomizations(encoded) {
    let customizations = {};
    try {
      customizations = customizationDecoder(encoded);
    } catch (e) {
      console.error(
        "Error: Could not load customizations. Invalid preview link."
      );
      return null;
    }

    if (Object.keys(customizations).length === 0) {
      return null;
    }

    return customizations;
  }

  #queryParamValue(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  #queryFreeUrlRedirect() {
    const url = window.location.href;
    window.history.pushState({}, '', url.split("?")[0])
  }

  #generateUniqueUserId() {
    const userId = misc.values["user-id"];
    if (!userId) {
      misc.update({ "user-id": uuidv4() });
    }
  }
}
